import { BOOLEAN_SELECT_LIST_ITEMS, Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import {
  StudentServiceIndexFilter as StudentServiceIndexFilterModel,
  StudentServiceIndexFilterResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentServiceIndexFilter = (props: {
  filter: StudentServiceIndexFilterModel;
  setFilter: (value: StudentServiceIndexFilterModel) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentServiceIndexFilterResource>({});
  const properties = resource.properties || [];
  const serviceSubTypes = props.filter.serviceTypeId
    ? resource.serviceSubTypes?.filter((x) => x.serviceTypeId === props.filter.serviceTypeId) ?? []
    : [];

  useEffect(() => {
    ApiService.studentServiceIndexes.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const serviceTypeField = () => {
    const propertyName = pn<StudentServiceIndexFilterModel>("serviceTypeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={resource.serviceTypes?.find((x) => x.id === props.filter.serviceTypeId)}
        options={resource.serviceTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.serviceTypeId = value?.id;
              draft.serviceSubTypeId = undefined;
            })
          )
        }
      />
    );
  };

  const serviceSubTypeField = () => {
    const propertyName = pn<StudentServiceIndexFilterModel>("serviceSubTypeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={serviceSubTypes.find((x) => x.id === props.filter.serviceSubTypeId)}
        options={serviceSubTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.serviceSubTypeId = value?.id;
            })
          )
        }
      />
    );
  };

  const isForParent = () => {
    const propertyName = pn<StudentServiceIndexFilterModel>("isForParent");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        modelProperty={property}
        value={BOOLEAN_SELECT_LIST_ITEMS.find((x) => x.id === props.filter.isForParent)}
        options={BOOLEAN_SELECT_LIST_ITEMS}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.isForParent = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {serviceTypeField()}
      </Grid>

      {serviceSubTypes.length > 0 && (
        <Grid item xs={smallFieldBreakpoints}>
          {serviceSubTypeField()}
        </Grid>
      )}

      <Grid item xs={smallFieldBreakpoints}>
        {isForParent()}
      </Grid>
    </Grid>
  );
};
